import React from "react";
import MainAppBar from "../MainAppBar";

const Header = ({ children }) => (
  <>
    <MainAppBar />
  </>
);

export default Header;
